import { Button, Form, Input, Radio } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import { partnerInfoSelector } from "../../feature/referral-partners/referralPartnerSelector";
import {
  getW9FormRequest,
  updateW9FormRequest,
} from "../../feature/partner-details/partnerDetailsSlice";
import { w9FormSelector } from "../../feature/partner-details/partnerDetailsSelector";
import { Link } from "react-router-dom";

const W9Form = () => {
  const [taxPayer, setTaxPayer] = useState("social");
  const [taxPayerSocial, setTaxPayerSocial] = useState(null);
  const [taxPayerPayerEmployer, setTaxPayerEmployer] = useState(null);
  const [taxClassificationLimited, setTaxClassificationLimited] = useState("");
  const [taxClassificationOther, setTaxClassificationOther] = useState("");
  const [taxClassification, setTaxClassification] = useState(null);
  const [exemptionsBayee, setExemptionsBayee] = useState("");
  const [exemptionsFATCA, setExemptionsFATCA] = useState("");

  const { partnerInfo } = useSelector(({ referralPartnersState }) =>
    partnerInfoSelector(referralPartnersState)
  );
  const { w9FormContent, isUpdateW9Form } = useSelector(
    ({ partnerDetailsState }) => w9FormSelector(partnerDetailsState)
  );

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const onFormFinish = (values) => {
    let taxPayerNumber, taxClassification;
    const regex = new RegExp(/[^0-9-]/, "gi");
    if (
      (values.taxClassificationRadio === "limited" &&
        !taxClassificationLimited) ||
      (values.taxClassificationRadio === "other" && !taxClassificationOther)
    ) {
      form.setFields([
        {
          name: "taxClassificationRadio",
          errors: ["Please input your answer!"],
        },
      ]);
      return;
    } else {
      form.setFields([
        {
          name: "taxClassificationRadio",
          errors: [],
        },
      ]);
    }

    if (values.taxClassificationRadio === "limited") {
      taxClassification = taxClassificationLimited;
    } else if (values.taxClassificationRadio === "other") {
      taxClassification = taxClassificationOther;
    }

    if (taxPayer === "social") {
      if (!taxPayerSocial) {
        form.setFields([
          {
            name: "part1",
            errors: ["Please input your answer!"],
          },
        ]);
        return;
      } else {
        form.setFields([
          {
            name: "part1",
            errors: [],
          },
        ]);

        let matchs = taxPayerSocial.replace(regex, "");
        matchs = matchs.split("-");
        if (
          matchs[0].length === 3 &&
          matchs[1].length === 2 &&
          matchs[2].length === 4
        ) {
          taxPayerNumber = taxPayerSocial;
        } else {
          form.setFields([
            {
              name: "part1",
              errors: ["Please input correct number!"],
            },
          ]);
          return;
        }
      }
    } else if (taxPayer === "employer") {
      if (!taxPayerPayerEmployer) {
        form.setFields([
          {
            name: "part1",
            errors: ["Please input your answer!"],
          },
        ]);
        return;
      } else {
        form.setFields([
          {
            name: "part1",
            errors: [],
          },
        ]);

        let matchs = taxPayerPayerEmployer.replace(regex, "");
        matchs = matchs.split("-");
        if (matchs[0].length === 2 && matchs[1].length === 7) {
          taxPayerNumber = taxPayerPayerEmployer;
        } else {
          form.setFields([
            {
              name: "part1",
              errors: ["Please input correct number!"],
            },
          ]);
          return;
        }
      }
    }
    dispatch(
      updateW9FormRequest({
        ...values,
        exemptionsBayee,
        exemptionsFATCA,
        taxClassification,
        taxPayerNumber,
        partnerId: partnerInfo._id,
      })
    );
  };

  // useEffect(() => {
  //   setTaxPayerSocial(null);
  //   setTaxPayerEmployer(null);
  // }, [taxPayer]);

  useEffect(() => {
    dispatch(getW9FormRequest(partnerInfo._id));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (w9FormContent) {
      form.setFieldsValue(w9FormContent);

      ["limited", "other"].includes(w9FormContent.taxClassificationRadio) &&
        setTaxClassification(w9FormContent.taxClassificationRadio);
      if (w9FormContent.taxClassificationRadio === "limited") {
        setTaxClassificationLimited(w9FormContent.taxClassification);
      } else if (w9FormContent.taxClassificationRadio === "other") {
        setTaxClassificationOther(w9FormContent.taxClassification);
      }

      if (w9FormContent.exemptionsBayee) {
        setExemptionsBayee(w9FormContent.exemptionsBayee);
      }
      if (w9FormContent.exemptionsFATCA) {
        setExemptionsFATCA(w9FormContent.exemptionsFATCA);
      }

      w9FormContent.part1Radio && setTaxPayer(w9FormContent.part1Radio);
      if (w9FormContent.part1Radio === "social") {
        setTaxPayerSocial(w9FormContent.taxPayerNumber);
      } else if (w9FormContent.part1Radio === "employer") {
        setTaxPayerEmployer(w9FormContent.taxPayerNumber);
      }
    }
  }, [form, w9FormContent]);

  return (
    <div className="w9Form-container">
      <h4>Request for Taxpayer Identification Number and Certification</h4>
      <h4>
        Go to{" "}
        <a href="https://www.irs.gov/FormW9" target="_blank" rel="noreferrer">
          www.irs.gov/FormW9
        </a>{" "}
        for instructions and the latest information.
      </h4>
      <br />
      <Form
        form={form}
        name="form"
        id="form"
        className="row-col max-w-1100"
        layout="vertical"
        onFinish={onFormFinish}
      >
        <div className="d-flex">
          <Form.Item
            className="flex-1"
            name="name"
            label="1. Name (as shown on your income tax return):"
            rules={[
              {
                required: true,
                message: "Please input your name!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="flex-1 ml-5"
            name="businessName"
            label="2. Business Name / disregarded entity name, if different from Name:"
          >
            <Input />
          </Form.Item>
        </div>
        <Form.Item
          name="taxClassificationRadio"
          label="3. Federal Tax Classification:"
          rules={[
            {
              required: true,
              message: "Please tick the box!",
            },
          ]}
        >
          <Radio.Group
            className="col-radio"
            onChange={(e) => setTaxClassification(e.target.value)}
          >
            <Radio value="individual">
              Individual/sole proprietor or single-member LLC
            </Radio>
            <Radio value="c-corporation">C Corporation</Radio>
            <Radio value="s-corporation">S Corporation</Radio>
            <Radio value="partnership">Partnership</Radio>
            <Radio value="trust">Trust/estate</Radio>
            <Radio value="limited">
              Limited liability company. Enter the tax classification (C=C
              corporation, S=S corporation, P=Partnership)
              {taxClassification === "limited" && (
                <Input
                  className="w-200"
                  value={taxClassificationLimited}
                  onChange={(e) => setTaxClassificationLimited(e.target.value)}
                />
              )}
            </Radio>
            <Radio value="other" className="other">
              Other
              {taxClassification === "other" && (
                <Input
                  className="w-100-p"
                  value={taxClassificationOther}
                  onChange={(e) => setTaxClassificationOther(e.target.value)}
                />
              )}
            </Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="exemptions"
          label="4. Exemptions (codes apply only to certain entities, not individuals) :"
        >
          <div>
            Exempt payee code (if any):{" "}
            <Input
              value={exemptionsBayee}
              onChange={(e) => setExemptionsBayee(e.target.value)}
              className="w-200"
            />
            <div style={{ marginTop: 8 }} />
            Exemption from FATCA reporting code (if any):{" "}
            <Input
              value={exemptionsFATCA}
              onChange={(e) => setExemptionsFATCA(e.target.value)}
              className="w-200"
            />
          </div>
        </Form.Item>
        <Form.Item
          name="address"
          label="5. Address:"
          rules={[
            {
              required: true,
              message: "Please enter information!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="zipcode"
          label="6. City, state, and ZIP code:"
          rules={[
            {
              required: true,
              message: "Please enter information!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="listAccountNumber"
          label="7. List account number(s) here:"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="part1Radio"
          label="Part I. Taxpayer Identification Number (TIN):"
          rules={[
            {
              required: true,
              message: "Please enter information!",
            },
          ]}
        >
          <Radio.Group
            className="col-radio"
            value={taxPayer}
            onChange={(e) => setTaxPayer(e.target.value)}
          >
            <p>
              Enter your TIN in the appropriate box. The TIN provided must match
              the name given above to avoid backup withholding. For individuals,
              this is generally your social security number (SSN). For other
              entities, it is your employer identification number (EIN).
            </p>
            <Radio value="social">
              Social security number{" "}
              {taxPayer === "social" && (
                <NumberFormat
                  className="w-200 mt-5"
                  customInput={Input}
                  format="###-##-####"
                  mask="_"
                  allowEmptyFormatting
                  value={taxPayerSocial}
                  onValueChange={(values) =>
                    setTaxPayerSocial(values.formattedValue)
                  }
                />
              )}
            </Radio>
            <Radio value="employer">
              Employer identification number{" "}
              {taxPayer === "employer" && (
                <NumberFormat
                  className="w-200 mt-5"
                  customInput={Input}
                  format="##-#######"
                  mask="_"
                  allowEmptyFormatting
                  value={taxPayerPayerEmployer}
                  onValueChange={(values) =>
                    setTaxPayerEmployer(values.formattedValue)
                  }
                />
              )}
            </Radio>
          </Radio.Group>
        </Form.Item>
        <div className="text-center">
          <Button type="primary" htmlType="submit" loading={isUpdateW9Form}>
            Submit
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default W9Form;
